import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';
import { QUERY_KEYS } from '@/utils/query-keys';

const service = PsychosocialReportService.getInstance();

export function useCreateEmployeeSurveyResult() {
	const queryClient = useQueryClient();

	return useMutation(
		(params: { participation_id: string; employee_id?: string | null; survey_id: string }) =>
			service.createEmployeeSurveyResult(params),
		{
			onSuccess: () => {
				message.success(I18n.get('Survey completed successfully!'));
				queryClient.invalidateQueries([QUERY_KEYS.GET_COMPLETED_SURVEYS]);
			},
			onError: () => {
				message.error(I18n.get('Failed to complete survey'));
			}
		}
	);
}
